import { render, staticRenderFns } from "./ChatContacts.vue?vue&type=template&id=17ce1292&"
import script from "./ChatContacts.vue?vue&type=script&lang=ts&"
export * from "./ChatContacts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports